
import { defineComponent, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  HardwareInfoService,
  HardwareRes
} from '@/views/dashboard/group/client/terminal-info/hardware-info/hardware-info.service'

export default defineComponent({
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const injector = useReflectiveInjector([HardwareInfoService])
    const service = injector.get(HardwareInfoService)

    const compData = ref({} as HardwareRes)
    const isLoading = ref(false)

    function updateData () {
      isLoading.value = true
      service.getHardware({
        device_id: props.deviceId
      }).then(res => {
        compData.value = res
      }).finally(() => {
        isLoading.value = false
      })
    }

    updateData()

    return {
      compData,
      isLoading,
    }
  }
})
